import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { blue } = colorsPalettes;

export const AllReadySetDefaultContainer = styled(FlexRow)`
    align-items: center;
    gap: 4px;

    padding: 8px 16px;

    & svg polygon {
        fill: ${blue[400]};
    }
`;

AllReadySetDefaultContainer.displayName = "AllReadySetDefaultContainer";

export const DefaultText = styled.span`
    ${setFontVariant("button", blue[400])};
`;

DefaultText.displayName = "DefaultText";
